import { supabase } from '@/lib/supabase/client'

export const uploadImage = async (file: File, bucket: string = 'images') => {
  // Strict validation to ensure we have a valid File object
  if (!file) {
    throw new Error('No file provided')
  }

  // Ensure the object is actually a File or Blob to prevent passing invalid objects
  // that might contain non-serializable data to the upload function
  if (!(file instanceof File) && !(file instanceof Blob)) {
    throw new Error('Invalid file format. Expected a File or Blob object.')
  }

  const fileExt = file.name.split('.').pop()
  const fileName = `${Math.random().toString(36).substring(2, 15)}_${Date.now()}.${fileExt}`
  const filePath = `${fileName}`

  try {
    const { error: uploadError } = await supabase.storage
      .from(bucket)
      .upload(filePath, file)

    if (uploadError) {
      // Create a new clean Error object with just the message string.
      // This strips away any complex properties (like FormData/Request objects) that might be attached to the Supabase error.
      throw new Error(uploadError.message || 'Upload failed')
    }

    const { data } = supabase.storage.from(bucket).getPublicUrl(filePath)

    if (!data || !data.publicUrl) {
      throw new Error('Failed to retrieve public URL')
    }

    return data.publicUrl
  } catch (error: any) {
    // Sanitize the error before rethrowing.
    // This is crucial to prevent "FormData object could not be cloned" errors
    // which happen when non-serializable objects are passed to window.postMessage (e.g., by Vite's error overlay).
    const message =
      error instanceof Error
        ? error.message
        : 'An unexpected error occurred during upload'
    throw new Error(message)
  }
}
